import { Controller, useFormContext } from "react-hook-form";
import { Textarea, TextAreaProps } from "./textarea";

export type ControlledTextareaProps = Omit<
  TextAreaProps,
  "onValueChange" | "errorMessage"
> & {
  name: string;
};

export function ControlledTextarea(props: ControlledTextareaProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => {
        return (
          <Textarea
            {...field}
            {...fieldState}
            onValueChange={field.onChange}
            {...props}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error?.message}
            value={field.value ?? ""}
          />
        );
      }}
    />
  );
}
